import { environment } from '@lla-platform/core/core-util'

export const EMPLOYEE_API_URL = {
  getEmployee: (id: string) => `${environment.apiUrl}/employee/${id}`,
  updateEmployee: `${environment.apiUrl}/employee/update`,
  employeeList: `${environment.apiUrl}/employee/filters`,
  exportEmployeeList: `${environment.apiUrl}/employee/filters/export`
}
